/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 4;
      this.products = '';

      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');

        if (recentIds && typeof recentIds !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }

    connectedCallback() {
      this.buildUrl();
    }

    fixJudgeMeBadges() {
      if (window.jdgm && typeof window.jdgm.refreshBadges === 'function') {
        window.jdgm.refreshBadges();
      }

      this.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
        const rating = parseFloat(badge.getAttribute('data-average-rating'));
        const widget = badge.closest('.jdgm-widget.jdgm-preview-badge');
        const text = badge.querySelector('.jdgm-prev-badge__text');

        if (!rating || rating === 0) {
          if (widget) {
            widget.style.display = 'none';
          }
          return;
        }

        if (widget) {
          widget.style.display = '';
        }

        if (text) {
          text.textContent = rating.toFixed(2);
        }

        badge.style.display = 'inline-flex';
      });
    }

    buildUrl() {
      if (!window.recentlyViewedIds || !window.recentlyViewedIds.length) {
        return;
      }

      let i = 0;

      window.recentlyViewedIds.forEach((val) => {
        if (val === this.currentId) {
          return;
        }

        if (i >= this.max) {
          return;
        }

        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      if (!this.products) {
        return;
      }

      this.products = this.products.replace(/\sOR\s$/, '');
      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }

    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');

            setTimeout(() => {
              this.fixJudgeMeBadges();
            }, 300);

            setTimeout(() => {
              this.fixJudgeMeBadges();
            }, 1000);
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}